/**
 * Holds a doctor share-link's practitionerId across the login screen, for
 * the case where a patient taps a share link while logged out. The link's
 * `dr/:practitionerId` route isn't mounted until a patient session exists
 * (see RootStackNavigator), so React Navigation's own linking resolution
 * can't carry it through login on its own - this is captured directly from
 * the raw incoming URL instead (see App.native.tsx) and consumed once the
 * app observes a patient becoming logged in (see RootStackNavigator).
 *
 * Intentionally in-memory only, not persisted: it only needs to survive the
 * login screen within the same app session, not across app restarts.
 */
let pendingPractitionerId: string | null = null;

const setPendingSharedPractitionerId = (practitionerId: string) => {
  pendingPractitionerId = practitionerId;
};

const consumePendingSharedPractitionerId = (): string | null => {
  const id = pendingPractitionerId;
  pendingPractitionerId = null;
  return id;
};

const extractSharedPractitionerIdFromUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  const match = url.match(/\/dr\/([^/?#]+)/);
  return match ? match[1] : null;
};

export {
  setPendingSharedPractitionerId,
  consumePendingSharedPractitionerId,
  extractSharedPractitionerIdFromUrl,
};
